<template>
  <v-container fluid>
    <v-card outlined>
      <v-card-text>
        <payment-method-settings-table
          :payment-methods="paymentMethods"
          :loading="loading"
          @open-new="openNewDialog"
          @edit="openEditDialog"
          @delete="openDeleteDialog"
          @toggle-activate="toggleActivate"
        />

        <payment-method-form-dialog
          v-if="formDialog"
          v-model="formDialog"
          :form-value="selectedPaymentMethod"
          @validateForm="savePaymentMethod"
          @close="formDialog = false"
        />

        <yes-no-dialog
          v-model="deleteDialog"
          :title="$t('settings.paymentMethod.deletePaymentMethod')"
          :text="deleteConfirmationText"
          @validate="deleteItem"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import PaymentMethodSettingsTable from './PaymentMethodSettingsTable.vue'
import PaymentMethodFormDialog from '../dialogs/PaymentMethodFormDialog.vue'
import YesNoDialog from '../dialogs/YesNoDialog.vue'

export default {
  name: 'PaymentMethodSettings',
  components: {
    PaymentMethodSettingsTable,
    PaymentMethodFormDialog,
    YesNoDialog,
  },
  props: {
    loadedSettings: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formDialog: false,
      deleteDialog: false,
      selectedPaymentMethod: undefined,
    }
  },
  computed: {
    paymentMethods() {
      return this.loadedSettings.payments?.payment_methods || []
    },
    deleteConfirmationText() {
      const label = this.getLabel(this.selectedPaymentMethod)
      return this.$t('settings.paymentMethod.deletePaymentMethodConfirmation', { label })
    },
  },
  methods: {
    getLabel(item) {
      if (!item) {
        return ''
      }
      const locale = this.$i18n.locale
      return item.labels?.[locale] || item.labels?.en || ''
    },
    openNewDialog() {
      this.selectedPaymentMethod = undefined
      this.formDialog = true
    },
    openEditDialog(item) {
      this.selectedPaymentMethod = item
      this.formDialog = true
    },
    openDeleteDialog(item) {
      this.selectedPaymentMethod = item
      this.deleteDialog = true
    },
    savePaymentMethod(paymentMethod) {
      if (!this.loadedSettings.payments) {
        this.$set(this.loadedSettings, 'payments', { payment_methods: [] })
      }
      const currentMethods = this.loadedSettings.payments.payment_methods || []

      if (this.selectedPaymentMethod !== undefined) {
        const index = currentMethods.indexOf(this.selectedPaymentMethod)
        if (index !== -1) {
          currentMethods[index] = paymentMethod
          this.$set(this.loadedSettings.payments, 'payment_methods', [...currentMethods])
        }
      } else {
        this.$set(this.loadedSettings.payments, 'payment_methods', [paymentMethod, ...currentMethods])
      }

      this.formDialog = false
      this.selectedPaymentMethod = undefined
    },
    toggleActivate(item) {
      const methods = this.loadedSettings.payments?.payment_methods || []
      const index = methods.indexOf(item)
      if (index !== -1) {
        this.$set(methods[index], 'activate', !item.activate)
      }
    },
    deleteItem() {
      const methods = this.loadedSettings.payments?.payment_methods || []
      this.$set(this.loadedSettings.payments, 'payment_methods', methods.filter((m) => m !== this.selectedPaymentMethod))
      this.deleteDialog = false
      this.selectedPaymentMethod = undefined
    },
  },
}
</script>
